import { useTranslation } from 'react-i18next';
export const useCharacterSubClassesTypes = () => {
    const { t } = useTranslation();
    const barbarianSubClasses = [
        { value: 'berserker', label: t('character.subClasses.berserker') },
        { value: 'totem_warrior', label: t('character.subClasses.totem_warrior') },
    ];
    const bardSubClasses = [
        { value: 'lore', label: t('character.subClasses.lore') },
        { value: 'valor', label: t('character.subClasses.valor') },
    ];
    const clericSubClasses = [
        { value: 'knowledge', label: t('character.subClasses.knowledge') },
        { value: 'life', label: t('character.subClasses.life') },
        { value: 'light', label: t('character.subClasses.light') },
        { value: 'nature', label: t('character.subClasses.nature') },
        { value: 'tempest', label: t('character.subClasses.tempest') },
        { value: 'trickery', label: t('character.subClasses.trickery') },
        { value: 'war', label: t('character.subClasses.war') },
    ];
    const druidSubClasses = [
        { value: 'land', label: t('character.subClasses.land') },
        { value: 'moon', label: t('character.subClasses.moon') },
    ];
    const fighterSubClasses = [
        { value: 'champion', label: t('character.subClasses.champion') },
        { value: 'battle_master', label: t('character.subClasses.battle_master') },
        { value: 'eldritch_knight', label: t('character.subClasses.eldritch_knight') },
    ];
    const monkSubClasses = [
        { value: 'open_hand', label: t('character.subClasses.open_hand') },
        { value: 'shadow', label: t('character.subClasses.shadow') },
        { value: 'four_elements', label: t('character.subClasses.four_elements') },
    ];
    const paladinSubClasses = [
        { value: 'devotion', label: t('character.subClasses.devotion') },
        { value: 'ancients', label: t('character.subClasses.ancients') },
        { value: 'vengeance', label: t('character.subClasses.vengeance') },
    ];
    const rangerSubClasses = [
        { value: 'hunter', label: t('character.subClasses.hunter') },
        { value: 'beast_master', label: t('character.subClasses.beast_master') },
    ];
    const rogueSubClasses = [
        { value: 'thief', label: t('character.subClasses.thief') },
        { value: 'assassin', label: t('character.subClasses.assassin') },
        { value: 'arcane_trickster', label: t('character.subClasses.arcane_trickster') },
    ];
    const sorcererSubClasses = [
        { value: 'draconic', label: t('character.subClasses.draconic') },
        { value: 'wild_magic', label: t('character.subClasses.wild_magic') },
    ];
    const warlockSubClasses = [
        { value: 'archfey', label: t('character.subClasses.archfey') },
        { value: 'fiend', label: t('character.subClasses.fiend') },
        { value: 'great_old_one', label: t('character.subClasses.great_old_one') },
    ];
    const wizardSubClasses = [
        { value: 'abjuration', label: t('character.subClasses.abjuration') },
        { value: 'conjuration', label: t('character.subClasses.conjuration') },
        { value: 'divination', label: t('character.subClasses.divination') },
        { value: 'enchantment', label: t('character.subClasses.enchantment') },
        { value: 'evocation', label: t('character.subClasses.evocation') },
        { value: 'illusion', label: t('character.subClasses.illusion') },
        { value: 'necromancy', label: t('character.subClasses.necromancy') },
        { value: 'transmutation', label: t('character.subClasses.transmutation') },
    ];
    const allSubClasses = [
        ...barbarianSubClasses,
        ...bardSubClasses,
        ...clericSubClasses,
        ...druidSubClasses,
        ...fighterSubClasses,
        ...monkSubClasses,
        ...paladinSubClasses,
        ...rangerSubClasses,
        ...rogueSubClasses,
        ...sorcererSubClasses,
        ...warlockSubClasses,
        ...wizardSubClasses,
    ];
    return {
        barbarian: barbarianSubClasses,
        bard: bardSubClasses,
        cleric: clericSubClasses,
        druid: druidSubClasses,
        fighter: fighterSubClasses,
        monk: monkSubClasses,
        paladin: paladinSubClasses,
        ranger: rangerSubClasses,
        rogue: rogueSubClasses,
        sorcerer: sorcererSubClasses,
        warlock: warlockSubClasses,
        wizard: wizardSubClasses,
        allSubClasses: allSubClasses,
    };
};
